/* eslint-disable @typescript-eslint/no-explicit-any */

// Imports for external libraries go here.
import React, { FC, useRef } from 'react';
import { MapInfoWindow, MapMarker, MapMarkerCluster } from '@marriott/mi-ui-library';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { MapClustersComponentProps } from './MapClustersComponent.types';
import { StyledMapClustersComponent } from './MapClustersComponent.styles';
import { HotelCard } from '../HotelCard';
import { ClusterSvgIcon, MapPinActiveSvgIcon, MapPinSvgIcon } from '../../modules/constants/constant';
import { dataUrl } from '../../modules/helpers';

// Use named rather than default exports.
export const MapClustersComponent: FC<MapClustersComponentProps> = ({
  markers,
  openInfoWindow,
  setOpenInfoWindow,
  selectedMarker,
  setSelectedMarker,
  ctaLabel,
}) => {
  /**
   * Ref's here...
   */
  const clustererRef = useRef<any>();

  const mapMarkerOnClick = (markerData: any) => {
    setOpenInfoWindow(true);
    setSelectedMarker(markerData);
  };

  /**
   * Cluster's custom styles
   */
  const customClusterStyles = [
    {
      url: dataUrl(ClusterSvgIcon),
      textColor: 'white',
      width: 74,
      height: 74,
      textSize: 14,
      fontWeight: '500',
    },
  ];

  return (
    <StyledMapClustersComponent
      data-testid="luxury-MapClustersComponent"
      data-component-name="m-luxury-MapClustersComponent"
    >
      <MapMarkerCluster
        averageCenter={false}
        gridSize={40}
        onLoad={clusterer => {
          clustererRef.current = clusterer;
        }}
        options={{
          imagePath: '', // Empty string to disable default cluster icon
          styles: customClusterStyles, // Use the custom cluster styles
        }}
        zoomOnClick={true}
      >
        {(clusterer: any) => (
          <>
            {markers?.map((marker: any, index: number) => (
              <React.Fragment key={marker.node.id || index}>
                <MapMarker
                  icon={{
                    url:
                      selectedMarker?.node?.basicInformation?.latitude === marker?.node?.basicInformation?.latitude &&
                      selectedMarker?.node?.basicInformation?.longitude === marker?.node?.basicInformation?.longitude &&
                      openInfoWindow
                        ? dataUrl(MapPinActiveSvgIcon)
                        : dataUrl(MapPinSvgIcon),
                  }}
                  label={{
                    text: ' ',
                    className: 'oval',
                  }}
                  position={{
                    lat: marker?.node?.basicInformation?.latitude,
                    lng: marker?.node?.basicInformation?.longitude,
                  }}
                  onClick={() => mapMarkerOnClick(marker)}
                  clusterer={clusterer}
                />
              </React.Fragment>
            ))}

            {selectedMarker && openInfoWindow && (
              <MapInfoWindow
                options={{ ariaLabel: 'map-info-window' }}
                position={{
                  lat: selectedMarker?.node?.basicInformation?.latitude,
                  lng: selectedMarker?.node?.basicInformation?.longitude,
                }}
              >
                <HotelCard currentLocale={'en-US'} props={selectedMarker} ctaLabel={ctaLabel} />
              </MapInfoWindow>
            )}
          </>
        )}
      </MapMarkerCluster>
    </StyledMapClustersComponent>
  );
};
